import mixpanel from "mixpanel-browser";
import { LOGIN_TYPE } from "../../enums/enums";
import { env } from "../../env";
import { WindowConfig } from "../../types";
import { getProject } from "../../utils/local-storage";

export const windowWithType = window as unknown as WindowConfig;

const mixpanelToken = env.REACT_APP_MIXPANEL_TOKEN;

if (mixpanelToken) {
  mixpanel.init(mixpanelToken, {
    ignore_dnt: true,
    record_sessions_percent: 100,
    record_mask_text_selector: "none"
  });
}

export async function trackEvent(event: string, data?: object) {
  const project = getProject();

  //Mixpanel
  mixpanel.track(event, {
    ...data,
    projectId: project.id
  });

  // Gist
  windowWithType.gist && windowWithType.gist.track(event, { ...data, projectId: project.id });

  // Customer.io
  if (windowWithType._cio) {
    windowWithType._cio.track(event, data);
  }
}

export const handleTrackLoginEvent = ({ username, type }: { username: string, type: LOGIN_TYPE }) => {
  // Mixpanel
  // people.set() & identify() should be called together, only on Login
  mixpanel.identify(username);
  mixpanel.people.set({
    "$email": username,
    "$last_login": new Date()
  });

  // Gist
  if (windowWithType.gist) {
    windowWithType.gist.identify({
      email: username
    });
  }

  // Customer.io
  if (windowWithType._cio) {
    windowWithType._cio.identify({
      id: username,
      email: username
    });
  }

  trackEvent("user_login", { email: username, type });
}

/**
 * do not use data from getProject() because the user does not have a project initialized yet when this function is called
 * even if it returns a value, it might be from the project from the previous logged in user
 */
export const handleTrackSignUpEvent = ({ userId, username, type, gitAccountId }: { userId: string, username: string, type: LOGIN_TYPE, gitAccountId?: string }) => {
  // Mixpanel
  // alias() should be fired only once on SignUp
  if (type === "github" && gitAccountId) {
    mixpanel.alias(gitAccountId);       // link the gitAccountId with the auto-generated distinctId
  }
  mixpanel.alias(userId);               // link the userId with the auto-generated distinctId
  mixpanel.alias(username);             // link the email with the auto-generated distinctId

  // Gist
  if (windowWithType.gist) {
    windowWithType.gist.identify({
      email: username
    });
  }

  // Customer.io
  if (windowWithType._cio) {
    windowWithType._cio.identify({
      id: username,
      email: username
    });
  }

  // no need to call trackEvent function because this event is tracked from backend
}

export const handleTrackLogoutEvent = () => {
  mixpanel.reset()
}

/**
 * Add and register user to groups
 */
export const handleSetMixpanelUserGroups = (projectIds: string[]) => {
  for (const id of projectIds) {
    mixpanel.add_group("projectId", id);        // add a new group for current user
  }
  mixpanel.set_group("projectId", projectIds);  // register the user in the groups
}

/**
 * Update projectId group profile
 */
export const handleSetMixpanelGroup = () => {
  const project = getProject();
  // Mixpanel group profile
  mixpanel.get_group("projectId", project.id).set({
    "projectId": project.id,
    "projectName": project.name,
    "projectDescription": project.description
  });
}
